'use strict';

var React = require('react');
var dequal = require('dequal');
var vectorPlugin = require('./vector-plugin-dc78d9b0.cjs.prod.js');
var reactUseGesture = require('react-use-gesture');
require('v8n');
var react = require('@stitches/react');
var text = require('clipboard-polyfill/text');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

const schemas = [];
const Plugins = {};
function getValueType({
  value,
  ...settings
}) {
  for (let checker of schemas) {
    const type = checker(value, settings);
    if (type) return type;
  }

  return undefined;
}
function normalize(type, input) {
  const {
    normalize: _normalize
  } = Plugins[type];
  if (_normalize) return _normalize(input);
  return input;
}
function register(type, {
  schema,
  ...plugin
}) {
  if (type in Plugins) {
    vectorPlugin.warn(vectorPlugin.LevaErrors.ALREADY_REGISTERED_TYPE, type);
    return;
  }

  if (schema) {
    schemas.push((value, settings) => schema(value, settings) && type);
  }

  Plugins[type] = plugin;
}

const getUniqueType = () => '__CUSTOM__PLUGIN__' + Math.random().toString(36).substr(2, 9);

function createPlugin(plugin) {
  const type = getUniqueType();
  register(type, plugin);
  return input => ({
    type,
    ...input
  });
}

function normalizeInput(input, path) {
  if (typeof input === 'object') {
    if ('type' in input) {
      // if it's a special input then we return it as it is
      if (input.type in vectorPlugin.SpecialInputTypes) return input; // if type exists at this point, it must be a custom plugin
      // defined by the user

      const {
        type,
        ...rest
      } = input;
      return {
        type,
        ...normalize(type, {
          value: rest
        })
      };
    }

    const type = getValueType(input);
    if (type) return {
      type,
      ...normalize(type, input)
    };
  }

  const type = getValueType({
    value: input
  });
  if (!type) return vectorPlugin.warn(vectorPlugin.LevaErrors.UNKNOWN_INPUT, path, input);
  return {
    type,
    ...normalize(type, {
      value: input
    })
  };
}
const isInput = v => '__levaInput' in v;

function sanitize(type, value, settings) {
  const {
    sanitize
  } = Plugins[type];
  if (sanitize) return sanitize(value, settings);
  return value;
}

function validate(type, value, settings) {
  const {
    validate
  } = Plugins[type];
  if (validate) return validate(value, settings);
  return true;
}

function updateInput(input, newValue) {
  const {
    value,
    type,
    settings
  } = input;
  input.value = sanitizeValue({
    type,
    value,
    settings
  }, newValue);
}

const ValueError = function (message, value) {
  this.message = 'LEVA: ' + message;
  this.previousValue = value;
};

function sanitizeValue({
  type,
  value,
  settings
}, newValue) {
  const _newValue = typeof newValue === 'function' ? newValue(value) : newValue;

  if (!validate(type, _newValue, settings)) {
    throw new ValueError(`The value [${newValue}] did not result in a correct value.`, value);
  }

  const sanitizedNewValue = sanitize(type, _newValue, settings);

  if (dequal.dequal(sanitizedNewValue, value)) {
    /**
     * @note This makes the update function throw when the new value is the same
     * as the previous one. This can happen for example, if the minimum value of
     * a number is 30, and the user inputs 15. Then the newValue will be sanitized
     * to 30 and subsequent calls like 14, 0, etc. won't result in the component displaying
     * the value to be notified (ie there wouldn't be a new render)
     */
    throw new ValueError(`The value [${newValue}] did not result in a value update, which remained the same: [${value}]. You can ignore this warning if this is the intended behavior.`, value);
  }

  return sanitizedNewValue;
}

const scales = {
  colors: {
    $gray900: '#181C20',
    $gray800: '#292D39',
    $gray700: '#373C4B',
    $grey600: '#535760',
    $gray500: '#8C92A4',
    $gray50: '#FEFEFE',
    $blue500: '#007BFF',
    $blue400: '#0066DC',
    $blue100: '#3C93FF'
  },
  radii: {
    $xs: '2px',
    $sm: '3px',
    $lg: '10px'
  }
};
const getDefaultTheme = () => ({
  colors: { ...scales.colors,
    $elevation1: scales.colors.$gray800,
    $elevation2: scales.colors.$gray900,
    $elevation3: scales.colors.$gray700,
    $accent: scales.colors.$blue500,
    $accent2: scales.colors.$blue400,
    $accent3: scales.colors.$blue100,
    $text: scales.colors.$gray500,
    $textEmphasized: scales.colors.$gray50,
    $textDeEmphasized: scales.colors.$grey600
  },
  radii: { ...scales.radii
  },
  space: {
    $input: '8px',
    $folderV: '8px',
    $rowH: '10px',
    $rowV: '4px',
    $colGap: '4px'
  },
  fonts: {
    $mono: `ui-monospace, SFMono-Regular, Menlo, 'Roboto Mono', monospace`
  },
  fontSizes: {
    $root: '11px'
  },
  sizes: {
    $rootWidth: '280px',
    $controlWidth: '160px',
    $scrubberWidth: '8px',
    $scrubberHeight: '16px',
    $rowHeight: '24px',
    $joystickWidth: '100px',
    $joystickHeight: '100px'
  },
  shadows: {
    $root: '0 0 9px 0 rgba(53,49,49,0.50);',
    $overlay: '0 4px 14px #00000033'
  },
  borderWidths: {
    $input: '1px',
    $root: '0px',
    $folder: '4px'
  },
  fontWeights: {
    $text: '600'
  },
  transitions: {
    $border: 'border-color 250ms ease',
    $bg: 'background-color 250ms ease',
    $borderBg: 'border-color, background-color 250ms ease'
  }
});
const {
  styled,
  css
} = react.createStyled({
  tokens: getDefaultTheme()
});
const globalStyles = css.global({
  '.leva__body__dragged': {
    userSelect: 'none',
    input: {
      userSelect: 'none'
    },
    '*': {
      cursor: 'ew-resize !important'
    }
  }
});

const InputContext = /*#__PURE__*/React.createContext({});
const ThemeContext = /*#__PURE__*/React.createContext({});

function mergeTheme(newTheme) {
  const mergedTheme = getDefaultTheme();
  Object.keys(newTheme).forEach(key => {
    // @ts-ignore
    Object.assign(mergedTheme[key], newTheme[key]);
  });
  return {
    mergedTheme,
    themeCss: css.theme(newTheme)
  };
}
function useTh(category, key) {
  const theme = React.useContext(ThemeContext);

  if (!(category in theme) || !(key in theme[category])) {
    vectorPlugin.warn(vectorPlugin.LevaErrors.THEME_ERROR, category, key);
    return '';
  }

  return theme[category][key];
}

const StyledWrapper = styled('div', {
  position: 'relative',
  background: '$elevation2',
  transition: 'height 350ms ease',
  variants: {
    isRoot: {
      true: {
        borderRadius: '$lg',
        padding: '0 $rowH'
      },
      false: {
        paddingLeft: '$rowH',
        '::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          width: '1px',
          height: '100%',
          backgroundColor: '$elevation1',
          transition: '$bg'
        }
      }
    },
    toggled: {
      false: {
        overflow: 'hidden'
      }
    }
  }
});
const StyledTitle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  color: '$textEmphasized',
  userSelect: 'none',
  cursor: 'pointer',
  paddingTop: '$folderV',
  '> svg': {
    marginLeft: -4,
    marginRight: 4,
    cursor: 'pointer',
    fill: '$elevation3'
  }
});
const StyledFolder = styled('div', {
  ':hover': {
    [`> ${StyledTitle} > svg`]: {
      fill: '$textDeEmphasized'
    },
    [`> ${StyledWrapper}::after`]: {
      backgroundColor: '$textDeEmphasized'
    }
  },
  variants: {
    isRoot: {
      true: {
        marginTop: 0
      }
    }
  }
});
const StyledContent = styled('div', {
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: '100%',
  gridRowGap: '$rowV',
  transition: 'opacity 250ms ease',
  variants: {
    toggled: {
      true: {
        opacity: 1,
        transitionDelay: '250ms'
      },
      false: {
        opacity: 0,
        transitionDelay: '0ms',
        pointerEvents: 'none'
      }
    },
    isRoot: {
      true: {
        padding: 'calc(2 * var(--space-rowV)) 0',
        [`& > ${StyledFolder}`]: {
          marginLeft: 0,
          [`& > ${StyledWrapper}`]: {
            borderWidth: 'calc(var(--borderWidths-folder) - var(--borderWidths-root))'
          }
        }
      }
    }
  }
});

function format(type, value, settings) {
  const {
    format
  } = Plugins[type];
  if (format) return format(value, settings);
  return value;
}

function useLevaUpdate({
  value,
  type,
  settings,
  set
}) {
  // the value used by the panel vs the value
  const [displayValue, setDisplayValue] = React.useState(format(type, value, settings));
  const setFormat = React.useCallback(v => setDisplayValue(format(type, v, settings)), [type, settings]);
  const onUpdate = React.useCallback(updatedValue => {
    try {
      set(updatedValue);
    } catch ({
      previousValue
    }) {
      setFormat(previousValue);
    }
  }, [setFormat, set]);
  React.useEffect(() => {
    setFormat(value);
  }, [value, setFormat]);
  return {
    displayValue,
    onChange: setDisplayValue,
    onUpdate
  };
}

const useDrag = (handler, config) => {
  return reactUseGesture.useDrag(state => {
    if (state.first) document.body.classList.add('leva__body__dragged');else if (state.last) document.body.classList.remove('leva__body__dragged');
    return handler(state);
  }, config);
};

function useDragNumber({
  settings,
  onDrag
}) {
  const {
    step
  } = settings;
  return useDrag(({
    delta: [dx],
    shiftKey
  }) => {
    const _step = shiftKey ? step : step * 2;

    onDrag(v => vectorPlugin.sanitizeStep(v + vectorPlugin.ceil(dx) * _step, settings));
  });
}

function useCanvas2d(fn) {
  const canvas = React.useRef(null);
  const ctx = React.useRef(null);
  React.useEffect(() => {
    const handleCanvas = vectorPlugin.debounce(() => {
      canvas.current.width = canvas.current.offsetWidth * window.devicePixelRatio;
      canvas.current.height = canvas.current.offsetHeight * window.devicePixelRatio;
      fn(canvas.current, ctx.current);
    }, 250);
    window.addEventListener('resize', handleCanvas);
    handleCanvas();
    return () => window.removeEventListener('resize', handleCanvas);
  }, [fn]);
  React.useEffect(() => {
    ctx.current = canvas.current.getContext('2d');
  }, []);
  return [canvas, ctx];
}

function useInputContext() {
  return React.useContext(InputContext);
}

const Row = styled('div', {
  position: 'relative',
  display: 'grid',
  gridRowGap: '$rowV',
  gridTemplateRows: 'minmax(var(--sizes-rowHeight), max-content)',
  alignItems: 'center',
  color: '$text',
  [`${StyledContent} > &`]: {
    ':first-of-type': {
      marginTop: '$rowV'
    },
    ':last-of-type': {
      marginBottom: '$rowV'
    }
  },
  variants: {
    input: {
      true: {
        gridTemplateColumns: 'auto var(--sizes-controlWidth)',
        gridColumnGap: '$colGap'
      }
    }
  }
});
const CopyLabelContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
  overflow: 'hidden',
  '> label': {
    cursor: 'pointer'
  },
  '> svg': {
    position: 'absolute',
    right: 4,
    opacity: 0,
    marginLeft: '$colGap',
    width: 15,
    minWidth: 15,
    height: 15,
    backgroundColor: '$elevation2'
  },
  '&:hover > svg': {
    opacity: 1
  }
});
const StyledLabel = styled('label', {
  color: '$text',
  fontWeight: '$label',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
});

function LabelWithCopy(props) {
  const {
    value,
    valueKey
  } = useInputContext();
  const [copied, setCopied] = React.useState(false);

  const handleClick = async () => {
    try {
      await text.writeText(JSON.stringify({
        [valueKey]: value
      }));
      setCopied(true);
    } catch {
      vectorPlugin.warn(vectorPlugin.LevaErrors.CLIPBOARD_ERROR, {
        [valueKey]: value
      });
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(CopyLabelContainer, {
    onClick: handleClick,
    title: `Click to copy ${valueKey} value`,
    onPointerLeave: () => setCopied(false)
  }, /*#__PURE__*/React__default['default'].createElement(StyledLabel, props), !copied ? /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
  })) : /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  })));
}

function Label(props) {
  const {
    valueKey
  } = useInputContext();
  const copyClipboard = valueKey !== undefined;
  return copyClipboard ? /*#__PURE__*/React__default['default'].createElement(LabelWithCopy, props) : /*#__PURE__*/React__default['default'].createElement(StyledLabel, props);
}

const Svg = styled('svg', {
  fill: 'currentColor',
  transition: 'transform 350ms ease, fill 250ms ease'
});
function Chevron({
  toggled,
  ...props
}) {
  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    width: "9",
    height: "5",
    viewBox: "0 0 9 5",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: `rotate(${toggled ? 0 : -90}deg)`
    }
  }, props), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M3.8 4.4c.4.3 1 .3 1.4 0L8 1.7A1 1 0 007.4 0H1.6a1 1 0 00-.7 1.7l3 2.7z"
  }));
}

const StyledInput = styled('input', {
  /* input reset */
  background: 'transparent',
  appearance: 'none',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  color: 'inherit',
  padding: '0 $input',
  backgroundColor: 'transparent',
  width: 0,
  minWidth: 0,
  // calc accounts for the container borders
  height: 'calc(var(--sizes-rowHeight) - 2 * var(--borderWidths-input))',
  flex: 1,

  /* input styling */
  border: 'none',
  outline: 'none',
  variants: {
    isNumber: {
      true: {
        textAlign: 'right'
      }
    }
  }
});
const InnerLabel = styled('div', {
  height: '100%',
  '& > :first-of-type': {
    width: '14px',
    height: '100%',
    marginRight: '-$input',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    opacity: '0.3',
    fontSize: '0.8em',
    cursor: 'ew-resize',
    userSelect: 'none',
    '&:hover': {
      opacity: 0.8
    }
  }
});
const InputContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  borderRadius: '$sm',
  border: '$input solid transparent',
  color: '$textEmphasized',
  backgroundColor: '$elevation3',
  transition: '$borderBg',
  '&:active': {
    borderColor: '$accent',
    backgroundColor: '$elevation1'
  },
  '&:hover': {
    borderColor: '$accent2'
  },
  '&:focus-within': {
    borderColor: '$accent'
  }
});

function ValueInput({
  children,
  value,
  onUpdate,
  onChange,
  onKeyDown,
  isNumber = false,
  ...props
}) {
  const update = React.useCallback(fn => event => {
    const _value = event.currentTarget.value;
    fn(_value);
  }, []);
  const onKeyPress = React.useCallback(e => {
    if (e.key === 'Enter') {
      update(onUpdate)(e); // e.currentTarget.blur()
    }
  }, [update, onUpdate]);
  return /*#__PURE__*/React__default['default'].createElement(InputContainer, null, children && /*#__PURE__*/React__default['default'].createElement(InnerLabel, null, children), /*#__PURE__*/React__default['default'].createElement(StyledInput, _extends({
    isNumber: isNumber,
    type: "text"
  }, props, {
    spellCheck: "false",
    value: value,
    onChange: update(onChange),
    onBlur: update(onUpdate),
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown
  })));
}

const RangeGrid = styled('div', {
  variants: {
    hasRange: {
      true: {
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: '3fr 2fr',
        gridColumnGap: '$colGap',
        alignItems: 'center'
      }
    }
  }
});

const Range = styled('div', {
  position: 'relative',
  width: '100%',
  height: '2px',
  borderRadius: '$xs',
  backgroundColor: '$elevation1'
});
const Scrubber = styled('div', {
  position: 'absolute',
  width: '$scrubberWidth',
  height: '$scrubberHeight',
  borderRadius: '$xs',
  boxShadow: '0 0 0 2px $elevation2',
  backgroundColor: '$accent',
  cursor: 'pointer',
  variants: {
    position: {
      left: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        transform: 'translateX(calc(-0.5 * ( var(--sizes-scrubberWidth) + 4px ) ))'
      },
      right: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        transform: 'translateX(calc(0.5 * ( var(--sizes-scrubberWidth) + 4px ) ))'
      }
    }
  }
});
const RangeWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  margin: '0 $input',
  cursor: 'pointer',
  touchAction: 'none'
});
const Indicator = styled('div', {
  position: 'absolute',
  height: '100%',
  backgroundColor: '$accent'
});

function RangeSlider({
  value,
  min,
  max,
  onDrag,
  step,
  initialValue
}) {
  const ref = React.useRef(null);
  const scrubberRef = React.useRef(null);
  const rangeWidth = React.useRef(0);
  const scrubberWidth = useTh('sizes', '$scrubberWidth');
  const bind = useDrag(({
    event,
    first,
    xy: [x],
    movement: [mx],
    memo
  }) => {
    if (first) {
      // rangeWidth is the width of the slider el minus the width of the scrubber el itself
      const {
        width,
        left
      } = ref.current.getBoundingClientRect();
      rangeWidth.current = width - parseFloat(scrubberWidth);
      const targetIsScrub = event?.target === scrubberRef.current; // memo is the value where the user clicked on

      memo = targetIsScrub ? value : vectorPlugin.invertedRange((x - left) / width, min, max);
    }

    const newValue = memo + vectorPlugin.invertedRange(mx / rangeWidth.current, 0, max - min);
    onDrag(vectorPlugin.sanitizeStep(newValue, {
      step,
      initialValue
    }));
    return memo;
  });
  const pos = vectorPlugin.range(value, min, max);
  return /*#__PURE__*/React__default['default'].createElement(RangeWrapper, _extends({
    ref: ref
  }, bind()), /*#__PURE__*/React__default['default'].createElement(Range, null, /*#__PURE__*/React__default['default'].createElement(Indicator, {
    style: {
      left: 0,
      right: `calc(${1 - pos} * (100% - ${scrubberWidth}))`
    }
  })), /*#__PURE__*/React__default['default'].createElement(Scrubber, {
    ref: scrubberRef,
    style: {
      left: `calc(${pos} * (100% - ${scrubberWidth}))`
    }
  }));
}

function NumberInput({
  children,
  value,
  onUpdate,
  onChange
}) {
  const onKeyDown = React.useCallback(event => {
    const dir = event.key === 'ArrowUp' ? 1 : event.key === 'ArrowDown' ? -1 : 0;

    if (dir) {
      event.preventDefault();
      const step = event.altKey ? 0.1 : event.shiftKey ? 10 : 1;
      onUpdate(v => v + dir * step);
    }
  }, [onUpdate]);
  return /*#__PURE__*/React__default['default'].createElement(ValueInput, {
    value: value,
    onUpdate: onUpdate,
    onChange: onChange,
    onKeyDown: onKeyDown,
    isNumber: true
  }, children);
}

function NumberInner({
  valueKey,
  displayValue,
  onUpdate,
  onChange,
  settings
}) {
  const bind = useDragNumber({
    settings,
    onDrag: onUpdate
  });
  return /*#__PURE__*/React__default['default'].createElement(NumberInput, {
    value: displayValue,
    onUpdate: onUpdate,
    onChange: onChange
  }, /*#__PURE__*/React__default['default'].createElement("div", _extends({
    title: valueKey.length > 1 ? valueKey : ''
  }, bind(), {
    style: {
      touchAction: 'none'
    }
  }), valueKey.charAt(0)));
}
function Number() {
  const props = useInputContext();
  const {
    label,
    value,
    onUpdate,
    settings
  } = props;
  const {
    min,
    max
  } = settings;
  const hasRange = max !== Infinity && min !== -Infinity;
  return /*#__PURE__*/React__default['default'].createElement(Row, {
    input: true
  }, /*#__PURE__*/React__default['default'].createElement(Label, null, label), /*#__PURE__*/React__default['default'].createElement(RangeGrid, {
    hasRange: hasRange
  }, hasRange && /*#__PURE__*/React__default['default'].createElement(RangeSlider, _extends({
    value: value,
    onDrag: onUpdate
  }, settings)), /*#__PURE__*/React__default['default'].createElement(NumberInner, _extends({}, props, {
    valueKey: "value"
  }))));
}

function Coordinate({
  value,
  valueKey,
  settings,
  onUpdate
}) {
  const args = {
    type: 'NUMBER',
    value: value[valueKey],
    settings
  };

  const set = newValue => onUpdate({ ...value,
    [valueKey]: sanitizeValue(args, newValue)
  });

  const number = useLevaUpdate({ ...args,
    set
  });
  return /*#__PURE__*/React__default['default'].createElement(NumberInner, {
    valueKey: valueKey,
    value: value[valueKey],
    displayValue: number.displayValue,
    onUpdate: number.onUpdate,
    onChange: number.onChange,
    settings: settings
  });
}

function Vector({
  value,
  onUpdate,
  settings
}) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, Object.keys(value).map(key => /*#__PURE__*/React__default['default'].createElement(Coordinate, {
    key: key,
    valueKey: key,
    value: value,
    settings: settings[key],
    onUpdate: onUpdate
  })));
}

exports.Chevron = Chevron;
exports.Indicator = Indicator;
exports.InputContext = InputContext;
exports.Label = Label;
exports.Number = Number;
exports.Plugins = Plugins;
exports.Range = Range;
exports.RangeWrapper = RangeWrapper;
exports.Row = Row;
exports.Scrubber = Scrubber;
exports.StyledContent = StyledContent;
exports.StyledFolder = StyledFolder;
exports.StyledTitle = StyledTitle;
exports.StyledWrapper = StyledWrapper;
exports.ThemeContext = ThemeContext;
exports.ValueInput = ValueInput;
exports.Vector = Vector;
exports._extends = _extends;
exports.createPlugin = createPlugin;
exports.globalStyles = globalStyles;
exports.isInput = isInput;
exports.mergeTheme = mergeTheme;
exports.normalizeInput = normalizeInput;
exports.register = register;
exports.styled = styled;
exports.updateInput = updateInput;
exports.useCanvas2d = useCanvas2d;
exports.useDrag = useDrag;
exports.useDragNumber = useDragNumber;
exports.useInputContext = useInputContext;
exports.useLevaUpdate = useLevaUpdate;
exports.useTh = useTh;
